import type { Group } from '@/components/ButtonGroup/types';

export const buttonsGroup: Group[] = [
	{
		id: 'analyist-grid',
		text: {
			lg: 'Analyst grid',
			base: 'Grid'
		},
		iconName: 'grid'
	},
	{
		id: 'global-map',
		text: {
			lg: 'Global map',
			base: 'Map'
		},
		iconName: 'globe'
	}
];
